<mbs-modal
  #modal
  class="license-modal"
  [isCustomModal]="true"
  [loading]="optionsLoading()"
  [showFooter]="true"
  [title]="baseModal.data.title"
  [titleTextOverflow]="true">
  <div modal-body>
    <div class="pb-3">
      <span>{{ 'shared:licenses.licenseModal.pleaseReferTo' | i18next }}</span>
      <a
        href="{{ getLink() }}"
        target="_blank">
        {{ getLinkText() }}
      </a>
      <span>{{ 'shared:licenses.licenseModal.forMoreInformation' | i18next }}</span>
    </div>
    <mbs-form-group
      [title]="'shared:licenses.licenseModal.services' | i18next"
      [titleClasses]="'fw-bold'">
      @for (option of options(); track option.id) {
        <mbs-radio
          class="d-block mb-3"
          [formControl]="selectedLicenseType"
          [id]="'service-license-' + option.id"
          [label]="optionLabel"
          [labelContext]="option"
          [name]="'service-license'"
          [subtitle]="'shared:licenses.licenseModal.proratedNote' | i18next"
          [subtitleHide]="option.price === null"
          [subtitleOutside]="false"
          [value]="option.id" />
      }
    </mbs-form-group>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="!selectedValue()"
      [loading]="loading()"
      (click)="assign()"
      >{{ 'shared:buttons.activate' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >{{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>

<ng-template
  #optionLabel
  let-option>
  <span class="fw-semibold">{{ option.name }}</span>
  @if (option.price !== null) {
    <span class="fw-semibold">&ngsp;&ndash; {{ option.price | pricePrepayment | async }} {{ periodLabelKey() | i18next }}</span>
  }
</ng-template>
